import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { siteConfig } from '../data/siteConfig';
type CtaButtonProps = {
  tone?: 'onDark' | 'onLight';
  size?: 'default' | 'compact';
  fullWidth?: boolean;
  className?: string;
  href?: string;
};
export function CtaButton({
  tone = 'onLight',
  size = 'default',
  fullWidth = false,
  className = '',
  href: hrefOverride
}: CtaButtonProps) {
  // Falls back to the offer section until a real checkout URL is configured.
  const href = hrefOverride ?? siteConfig.checkoutUrl ?? '#offer';
  const toneClasses = tone === 'onDark' ? 'bg-ivory text-forest-dark hover:bg-white' : 'bg-forest text-white hover:bg-forest-dark';
  const sizeClasses = size === 'compact' ? 'h-11 px-5 text-[15px]' : 'h-14 px-8 text-base md:text-[17px]';
  return <a href={href} className={`group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl font-semibold shadow-sm transition-[background-color,transform] duration-150 ease-out active:scale-[0.98] ${toneClasses} ${sizeClasses} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-56" data-mp="19aa3hm3re6u5">
      {siteConfig.ctaLabel}
      {size === 'default' && <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-57" data-mp="3ey41u0htp3mn" />}
    </a>;
}